export const getTripsUrl = 'https://us-central1-labenu-apis.cloudfunctions.net/labeX/sarah/trips'
export const loginUrl = 'https://us-central1-labenu-apis.cloudfunctions.net/labeX/sarah/login'